import { TagDto } from '@/data/http/tags/tag.dto.schema.ts';
import { Tag } from '@/domain/tags/entities/tag.entity.ts';

type TagDtoOmit = Omit<TagDto, 'id'>;

export class TagMapper {
  static dtoToEntity(dto: TagDto): Tag {
    return {
      id: dto.id,
      name: dto.name,
    };
  }

  static entityToDto(tagName: string): TagDtoOmit {
    return {
      name: tagName,
    };
  }
}
